<template>
    <div>
        <div class="introduce">
        <div class="introduces flex">
            <div class="left">
                <router-link to="/">
                <i class="iconfont icon-a-SPRLOGO"></i>
                </router-link>
                <div class="flex wx-left">
<!--                    <img src="" class="wx">-->
                   <ul>
                       <li>电话：023-67665596,18580875987(张先生)</li>
                       <li>邮箱：swengin@163.com</li>
                       <li>地址：重庆市巴南区木洞镇天益路9号重庆国际生物城E3栋2单元</li>
                   </ul>
                </div>
            </div>
            <div class="right flex" style="justify-content: space-around">
                <div class="li">
                    <h4></h4>
                    <ul>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                </div>
                <div class="li">
                    <router-link to="/product">
                    <h4>产品</h4>
                    </router-link>
                    <ul>
                        <router-link to="/product?type=1">
                        <li>新能源材料</li>
                        </router-link>
                        <router-link to="/product?type=2">
                        <li>腈类化合物及其衍生物</li>
                        </router-link>
                        <router-link to="/product?type=3">
                        <li>基础化学品</li>
                        </router-link>
                    </ul>
                </div>
                <div class="li">
                    <router-link to="/cooperationOpportunities">
                    <h4>合作机会</h4>
                    </router-link>
                    <ul>
                        <router-link to="/cooperationOpportunities?type=1">
                        <li>生产资源合作</li>
                        </router-link>
                        <router-link to="/cooperationOpportunities?type=2">
                        <li>产品合作</li>
                        </router-link>
                    </ul>
                </div>
                <div class="li">
                    <router-link to="/InformationDynamics">
                    <h4>资讯与动态</h4>
                    </router-link>
                    <ul>
                        <router-link to="/InformationDynamics?type=1">
                        <li>行业资讯</li>
                        </router-link>
                        <router-link to="/InformationDynamics?type=2">
                        <li>公司动态</li>
                        </router-link>
                    </ul>
                </div>
                <div class="li">
                    <router-link to="/aboutUs">
                    <h4>关于我们</h4>
                    </router-link>
                    <ul>
                        <router-link to="/aboutUs?type=1">
                        <li>公司介绍</li>
                        </router-link>
                        <router-link to="/aboutUs?type=2">
                            <li>职业机会</li>
                        </router-link>
                        <router-link to="/aboutUs?type=3">
                        <li>联系我们</li>
                        </router-link>
                    </ul>
                </div>
            </div>
        </div>
        </div>
        <div class="bottom">
            <div class="flex bottoms">
            <div class="name">重庆市斯普瑞科技有限公司 版权所有</div>
            <div class="code"><a href="https://beian.miit.gov.cn" target="_blank" style="cursor: pointer;color: #FFFFFF" >备案序号：渝ICP备060540049号-1</a></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "footers"
    }
</script>

<style scoped>
    .introduce{
        width: 1200px;
        height: 272px;
        background: #EDF1F4;
    }
    .introduces{
        width: 1100px;margin-left: 50px;
        text-align: left;
    }
    .introduces i{
        font-size: 140px;
        margin-left: -10px;
    }
    .bottom{
        width: 1200px;
        background: #0067AC;
    }
    .bottoms{
        width: 1100px;justify-content: space-between;
        padding-left: 50px;box-sizing: border-box;
    }
    .bottom .name{
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #FFFFFF;
        height: 44px;
        line-height: 44px;
    }
    .bottom .code{
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #FFFFFF;
        height: 44px;
        line-height: 44px;
    }
    .wx{
        width: 97px;
        height: 97px;
    }
    .wx-left{
        margin-top: -30px;
    }
    .wx-left ul{
        margin-top: 10px;
    }
    .wx-left li{
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #363A44;
        line-height: 26px;
    }
    .right{
        width: 69%
    }
    .right ul{
        margin-top: -10px;
    }
    .right h4{
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #000000;
        line-height: 26px;
    }
    .right .li{
        margin-top: 96px;
    }
    .right li{
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: rgba(0, 0, 0, 0.48);
        line-height: 26px;
    }
    .right h4:hover{
        cursor: pointer;
    }
    .right li:hover{
        cursor: pointer;
    }
</style>
